import React, { useState, useEffect } from "react";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { AdminMenus } from "../../../components/recoil/atoms/Menus";

import Header from "../../components/includes/Header";
import Paging from "../../components/includes/Paging";
import CertificationSearch from "../../components/certifications/CertificationSearch";
import CertificationSearchResult from "../../components/certifications/CertificationSearchResult";
import {LoginAfterCheckLogin,ChangeSimpleDateString,PassedMonths} from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";


//수료증 관리
const CertificationList = () => {
  LoginAfterCheckLogin(0);  //로그인 상태 점검

  const [varAdminMenus,setAdminMenus] = useRecoilState(AdminMenus);

  //컬럼기본
  let columnList = [
      {Header:'번호',accessor:'nums',width:50},
      {Header:'센터명',accessor:'bh_company',width:100},
      {Header:'원생명',accessor:'ch_name',width:80},
      {Header:'개월',accessor:'ch_month',width:70},
      {Header:'생년월일',accessor:'ch_birthday',width:90},
      {Header:'출석회차',accessor:'ch_attendance',width:70},
      {Header:'레벨',accessor:'vl_name',width:110},
      {Header:'발급현황',accessor:'ce_state',width:70},
      {Header:'발급번호',accessor:'ce_code',width:90},
      {Header:'종류',accessor:'ce_lang_string',width:60},
      {Header:'영문명(원생)',accessor:'ch_ename',width:120},
      {Header:'영문명(센터)',accessor:'bh_ecompany',width:150},
      {Header:'발급희망일',accessor:'ce_idate',width:90},
      {Header:'발급신청일',accessor:'ce_rdate',width:90},
      {Header:'발급일',accessor:'ce_pdate',width:90},
      {Header:'상태',accessor:'ce_status',width:20},
      {Header:'고유번호',accessor:'ce_idx',width:20},
      {Header:'수업년수',accessor:'vl_terms',width:20},
  ];
  const [varColumnLists,setColumnLists] = useState([]);

  //수료증 목록
  const [varCertificationLists,setCertificationLists] = useState([]);
  //센터 목록
  const [varBranchList,setBranchList] = useState([]);
  //레벨 목록
  const [varLevelList,setLevelList] = useState([]);
  //검색년도
  const [varYearList, setYearList] = useState([]);
  
  //검색
  const [varSearchData, setSearchData] = useState({
    searchBranch:0,
    searchYear:0,
    searchLevel:0,
    searchStatus:0,
    searchOption:'all',
    searchString:''
  });

  //페이지
  const [varTotalCount, setTotalCount] = useState(0);
  const [varPageSize] = useState(10);
  const [varPageNum, setPageNum] = useState(1);
  
  //수료증 발급 목록 읽어오기
  const GetCertificationList = async () => {
    const sendData = {pageNum: varPageNum,pageSize: varPageSize,searchData: varSearchData};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_certification_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setTotalCount(datas.totalcount);
        let newArray = [];
        const pmax = datas.totalcount - (varPageNum - 1) * varPageSize;
        if(pmax > 0) {
          const dataArray = datas.results;
          for(var i=0; i < dataArray.length; i++) {
            const lineObj = dataArray[i];
            var newData = {};
            newData['nums'] = pmax - i;
            newData['bh_company'] = lineObj.bh_company;
            newData['ch_name'] = lineObj.ch_name;
            newData['ch_month'] = PassedMonths(lineObj.ch_birthday)+" 개월";
            newData['ch_birthday'] = ChangeSimpleDateString(lineObj.ch_birthday);
            newData['ch_attendance'] = lineObj.ch_attendance;
            newData['vl_idx'] = lineObj.vl_idx;
            newData['vl_name'] = lineObj.vl_name;
            newData['ce_state'] = lineObj.ce_status===1?"발급대기":"발급완료";
            newData['ce_lang_string'] = lineObj.ce_lang===1?"국문":"영문";
            newData['ce_code'] = lineObj.ce_code;
            newData['ce_lang'] = lineObj.ce_lang;
            newData['ch_ename'] = lineObj.ch_ename;
            newData['bh_ecompany'] = lineObj.bh_ecompany;
            newData['ce_idate'] = ChangeSimpleDateString(lineObj.ce_idate);
            newData['ce_rdate'] = ChangeSimpleDateString(lineObj.ce_rdate);
            newData['ce_pdate'] = ChangeSimpleDateString(lineObj.ce_pdate);
            newData['ce_status'] = lineObj.ce_status;
            newData['ce_idx'] = lineObj.ce_idx;
            newData['ce_issue'] = lineObj.ce_issue;
            newData['ce_file'] = lineObj.ce_file;
            newData['vl_terms'] = lineObj.vl_terms;
            newArray.push(newData);
          }
        }
        console.log(newArray);
        setCertificationLists(newArray);
        setBranchList(datas.branchs);
        setLevelList(datas.levels);
      } else {
        setCertificationLists([]);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setAdminMenus({type:'CERTIFICATION',item:'Certification'});
    console.log(varAdminMenus);
    setColumnLists(columnList);
    const ndate = new Date();
    //년도배열
    const nYear = ndate.getFullYear();
    let ayears = [];
    for(var i=0; i <10; i++) {
      ayears.push(nYear-i);
    }
    setYearList(ayears);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    GetCertificationList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varPageNum,varSearchData]);

  return varColumnLists.length===0?null:(
    <div id="admin_contents" className="adm_contents">
      <Header varTitle={"수료증 관리"} varDirection={'수료증 관리'}/>
      <div className="admin-content">
        <CertificationSearch varSearchData={varSearchData} setSearchData={setSearchData} varBranchList={varBranchList} 
                        setPageNum={setPageNum} varYearList={varYearList} varLevelList={varLevelList}/>
        <CertificationSearchResult varTotalCount={varTotalCount} varColumnLists={varColumnLists} varLevelList={varLevelList}
          varCertificationLists={varCertificationLists} GetCertificationList={GetCertificationList} varSearchData={varSearchData}/>
        <div className="paging" style={{ marginBottom: "20px" }}>
          <Paging totalCount={varTotalCount} pageSize={varPageSize} curPage={varPageNum} setPage={setPageNum} />
        </div>
      </div>
    </div>
  );
}
export default CertificationList;